/* F3 hero: the lookbook slideshow and the extruded gold ف behind the type.
   Ported from the approved design. Needs three.js and f3-marks.js. */
(function(){
  'use strict';
  var root = document.documentElement;
  function css(v){ return getComputedStyle(root).getPropertyValue(v).trim(); }
  var FAA = window.F3_FAA, THR = window.F3_THR;
  if (!FAA || !THR) return;

/* ── hero slideshow ───────────────────────────────────────────────── */
  var shw = document.getElementById('hero');
  if (shw) {
    var slides = [].slice.call(shw.querySelectorAll('.shw__f')),
        ticks  = document.getElementById('shwTicks'),
        live   = document.getElementById('shwLive'),
        reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches,
        cur = 0, timer = null, held = false;

    slides.forEach(function(_, i){
      var t = document.createElement('button');
      t.className = 'shw__tick'; t.type = 'button'; t.setAttribute('role','tab');
      t.setAttribute('aria-label', 'Frame ' + (i + 1) + ' of ' + slides.length);
      t.addEventListener('click', function(){ show(i); });
      ticks.appendChild(t);
    });
    var tickEls = [].slice.call(ticks.children);

    function show(i){
      cur = (i + slides.length) % slides.length;
      slides.forEach(function(s, n){ s.setAttribute('data-on', n === cur ? '1' : '0'); });
      tickEls.forEach(function(t, n){ t.setAttribute('aria-selected', n === cur ? 'true' : 'false'); });
      live.textContent = 'Frame ' + (cur + 1) + ' of ' + slides.length;
    }
    function play(){ if (!reduce && !held && !timer) timer = setInterval(function(){ show(cur + 1); }, 3500); }
    function stop(){ clearInterval(timer); timer = null; }

    document.getElementById('shwPrev').addEventListener('click', function(){ show(cur - 1); });
    document.getElementById('shwNext').addEventListener('click', function(){ show(cur + 1); });
    ['pointerenter','focusin'].forEach(function(e){ shw.addEventListener(e, function(){ held = true; stop(); }); });
    ['pointerleave','focusout'].forEach(function(e){ shw.addEventListener(e, function(){ held = false; play(); }); });
    document.addEventListener('visibilitychange', function(){ document.hidden ? stop() : play(); });

    show(0); play();
  }

  /* ── the extruded ف behind the hero ───────────────────────────────────
     Amiri's real contours, pushed into depth and lit like struck metal.
     It reads through the margins the contained photography leaves.      */
  (function(){
    var host = document.getElementById('shwBg');
    if (!host || !window.THREE) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ren, scn, cam, mark, exp, raf = null, seen = false, px = 0, py = 0, tx = 0, ty = 0;

    try { ren = new THREE.WebGLRenderer({ antialias:true, alpha:true }); } catch(e){ return; }
    var W = host.clientWidth || 1200, H = host.clientHeight || 700;
    ren.setPixelRatio(Math.min(devicePixelRatio, 2));
    ren.setSize(W, H, false);
    host.appendChild(ren.domElement);

    scn = new THREE.Scene();
    cam = new THREE.PerspectiveCamera(30, W / H, 0.1, 100);
    cam.position.set(0, 0, 7.2);

    // contours -> extruded geometry, in em units, y-up
    function build(src, depth){
      var u = src.upm, shapes = [];
      function ring(c){
        var pts = [];
        for (var i = 0; i < c.length; i++) pts.push(new THREE.Vector2(c[i][0] / u, c[i][1] / u));
        return pts;
      }
      src.shapes.forEach(function(sh){
        var s0 = new THREE.Shape(ring(src.contours[sh.outer]));
        sh.holes.forEach(function(hi){ s0.holes.push(new THREE.Path(ring(src.contours[hi]))); });
        shapes.push(s0);
      });
      var g = new THREE.ExtrudeGeometry(shapes, {
        depth:depth, bevelEnabled:true, bevelThickness:0.016,
        bevelSize:0.014, bevelSegments:3, curveSegments:2 });
      g.center();
      return g;
    }
    var geo = build(FAA, 0.21);

    var gold = new THREE.Color(css('--accent') || '#C8A040');
    var mat = new THREE.MeshStandardMaterial({
      color:gold, metalness:0.78, roughness:0.29, transparent:true, opacity:0.72,
      side:THREE.DoubleSide });

    function retheme(){
      var dark = !document.documentElement.matches('[data-theme="light"]') &&
                 !(matchMedia('(prefers-color-scheme: light)').matches &&
                   !document.documentElement.matches('[data-theme="dark"]'));
      var c = css('--accent') || '#C8A040';
      mat.color.set(c); rim.color.set(c);
      mat.opacity   = dark ? 0.72 : 0.86;   // ivory swallows a translucent mark
      mat.metalness = dark ? 0.82 : 0.66;
      mat.roughness = dark ? 0.31 : 0.38;
      mat.needsUpdate = true;
    }
    addEventListener('f3theme', retheme);
    matchMedia('(prefers-color-scheme: light)').addEventListener('change', retheme);

    mark = new THREE.Mesh(geo, mat);
    
    scn.add(mark);

    // the gold three - the exponent half of the mark - balancing the left margin
    exp = new THREE.Mesh(build(THR, 0.18), mat);
    scn.add(exp);

    scn.add(new THREE.AmbientLight(0xffffff, 0.22));
    var key = new THREE.DirectionalLight(0xffe6b0, 1.5); key.position.set(-3, 4, 6); scn.add(key);
    var rim = new THREE.DirectionalLight(gold, 2.5);     rim.position.set(5, -2, 2);  scn.add(rim);
    var fill= new THREE.DirectionalLight(0x6a5a30, 0.7); fill.position.set(2, 3, -4);  scn.add(fill);
    retheme();

    function size(){
      W = host.clientWidth || 1200; H = host.clientHeight || 700;
      ren.setSize(W, H, false); cam.aspect = W / H; cam.updateProjectionMatrix();
      var visH = 2 * Math.tan(30 * Math.PI / 360) * cam.position.z,
          visW = visH * cam.aspect;
      // fit the whole lockup to the column, whichever way it is constrained
      var k = Math.min(visW / 1.85, visH / 1.45);
      mark.scale.setScalar(k);
      mark.position.set(k * 0.26, -k * 0.12, 0);
      exp.scale.setScalar(k * 0.40);
      exp.position.set(k * 0.78, k * 0.32, 0.02);
    }
    size();
    addEventListener('resize', size, { passive:true });

    addEventListener('pointermove', function(e){
      tx = (e.clientX / innerWidth - 0.5) * 2;
      ty = (e.clientY / innerHeight - 0.5) * 2;
    }, { passive:true });

    function frame(t){
      px += (tx - px) * 0.045; py += (ty - py) * 0.045;
      // one revolution roughly every 22s; the exponent runs a touch slower so
      // the pair never locks into the same pose twice
      var spin = reduce ? -0.16 : (t * 0.000285);
      mark.rotation.y = spin + px * 0.16;
      mark.rotation.x = 0.06 + (reduce ? 0 : Math.sin(t * 0.00016) * 0.05) - py * 0.11;
      exp.rotation.y = (reduce ? 0.20 : spin * 0.82 + 0.4) + px * 0.20;
      exp.rotation.x = -0.05 + (reduce ? 0 : Math.sin(t * 0.00016 + 1.9) * 0.06) - py * 0.13;
      ren.render(scn, cam);
      raf = seen ? requestAnimationFrame(frame) : null;
    }
    // only burn frames while the hero is actually on screen
    new IntersectionObserver(function(en){
      seen = en[0].isIntersecting;
      if (seen && !raf) raf = requestAnimationFrame(frame);
    }, { threshold:0 }).observe(document.getElementById('hero'));
  })();
})();
